'use client';

import NextImageView from '@/components/ui/NextImageView/NextImageView';
import type { GfWorkDetail } from '@/features/gfWorks/types';
import { formatCreatorNames } from '@/utils/formatters';
import { getImageLayoutSizes } from '@/utils/nextImage';
import WorksDetailThumbnail from '../WorksDetailThumbnail/WorksDetailThumbnail';
import styles from './WorkDetailSidebar.module.scss';

function WorkDetailSidebar({ work }: { work: GfWorkDetail }) {
  return (
    <aside className={styles.sidebar}>
      {/* 作品画像 */}
      <div className={styles.workImageContainer}>
        <NextImageView
          src={work.imagePath}
          alt={work.name}
          fill
          sizes={getImageLayoutSizes({ sp: '24vw', pc: '200px' })}
          objectFit='contain'
        />
      </div>

      {/* 作品名 + クリエイター + コマデータ出典元 */}
      <div>
        <h2 className={styles.workName}>{work.name}</h2>
        <p className={styles.creatorName}>{formatCreatorNames(work.creators)}</p>
        <p className={styles.source}>
          <span className={styles.sourceLabel}>コマデータ出典元：</span>
          {work.source}
        </p>
      </div>

      <hr className={styles.divider} />

      <WorksDetailThumbnail work={work} />
    </aside>
  );
}

export default WorkDetailSidebar;
